export const    ISSUE = 'ISSUE';
export const    ISSUEV2 = 'ISSUEV2';
export const    ISSUE_SUCCESS = 'ISSUE_SUCCESS';
export const    ISSUE_ERROR = 'ISSUE_ERROR';

export const    ISSUE_ITEMS = 'ISSUE_ITEMS';
export const    ISSUE_ITEMS_SUCCESS = 'ISSUE_ITEMS_SUCCESS';
export const    ISSUE_ITEMS_ERROR = 'ISSUE_ITEMS_ERROR';

export const    ADD_ISSUE = 'ADD_ISSUE';
export const    ADD_ISSUE_SUCCESS = 'ADD_ISSUE_SUCCESS';
export const    ADD_ISSUE_ERROR = 'ADD_ISSUE_ERROR';

export const    UPDATE_ISSUE = 'UPDATE_ISSUE';
export const    UPDATE_ISSUE_SUCCESS = 'UPDATE_ISSUE_SUCCESS';
export const    UPDATE_ISSUE_ERROR = 'UPDATE_ISSUE_ERROR';


export const DELETE_ISSUE = 'DELETE_ISSUE';
export const DELETE_ISSUE_SUCCESS= 'DELETE_ISSUE_SUCCESS';
export const DELETE_ISSUE_ERROR ='DELETE_ISSUE_ERROR';